import { Routes, Router, ActivatedRouteSnapshot } from '@angular/router';
import { inject } from '@angular/core';

const meetingGuard = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const roomName = route.paramMap.get('roomName');
  const token = sessionStorage.getItem('telehealth_temp_token');

  if (!token) {
    if (roomName) {
      router.navigate([`/auth/${roomName}`]);
    } else {
      router.navigate(['/']);
    }
    return false;
  }
  return true;
};

export const routes: Routes = [
  // เส้นทางหลักรูปแบบใหม่ (New route formats)
  {
    path: 'auth/:roomName',
    loadComponent: () =>
      import('./components/auth/auth.component').then(
        (m) => m.AuthComponent
      ),
  },
  {
    path: 'meeting/:roomName',
    canActivate: [meetingGuard],
    loadComponent: () =>
      import('./components/customer-meeting/customer-meeting.component').then(
        (m) => m.CustomerMeetingComponent
      ),
  },

  // กฎการเปลี่ยนเส้นทางเพื่อรองรับลิงก์รูปแบบเดิม (Redirect rules for backward compatibility)
  {
    path: ':roomName/auth',
    redirectTo: 'auth/:roomName',
    pathMatch: 'full',
  },
  {
    path: ':roomName/meeting',
    redirectTo: 'meeting/:roomName',
    pathMatch: 'full',
  },
  {
    path: ':roomName',
    redirectTo: 'auth/:roomName',
    pathMatch: 'full',
  },

  // เส้นทางที่ไม่ถูกต้อง (Wildcard paths for 404 page)
  {
    path: 'auth/:roomName/**',
    loadComponent: () =>
      import('./components/page-not-found/page-not-found.component').then(
        (m) => m.PageNotFoundComponent
      ),
  },
  {
    path: 'meeting/:roomName/**',
    loadComponent: () =>
      import('./components/page-not-found/page-not-found.component').then(
        (m) => m.PageNotFoundComponent
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./components/page-not-found/page-not-found.component').then(
        (m) => m.PageNotFoundComponent
      ),
  },
];

